import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-formfields',
  templateUrl: './formfields.component.html',
  styleUrls: ['./formfields.component.css']
})
export class FormfieldsComponent extends BaseComponent implements OnInit {
  test: any = {};
  colors: any = [];
  constructor(injector: Injector) {super(injector)}

  ngOnInit(): void {
    this.test.name = "Peter";
    this.test.label = "This is a label";
    this.test.isHuman = true;
    this.test.age = 25;
    this.test.longtext = "ipse lorem and mucvh more. ipse lorem and mucvh more. ipse lorem and mucvh more. ipse lorem and mucvh more. ipse lorem and mucvh more. "
    this.test.colorid = 3;

    this.colors = [
      {id:1,name:'blue'},
      {id:2,name:'red'},
      {id:3,name:'green'},
      {id:4,name:'yellow'},
    ]
  }

}
